export const LOGOUT = "logout";

export const EUR_TO_RSD = 117.5;

/*
 * Jedan izvor istine za dostavu i plaćanje (v2 s.13.2 [CONFIG]).
 * SVAKI tekst na sajtu koji pominje prag/cenu dostave čita odavde.
 * [BIZNIS: potvrditi iznose pragova i rokove isporuke po državi]
 */
export const COUNTRY_CONFIG = {
  RS: {
    code: "RS",
    name: "Srbija",
    nameGenitive: "Srbiju", // "Poštarina za Srbiju"
    currency: "RSD",
    deliveryPrice: 600,
    freeShippingThreshold: 6000,
    pickupAllowed: true,
    phonePrefix: "+381",
    phonePlaceholder: "06x xxx xxxx",
    deliveryEstimate: "2–4 radna dana (PostExpres)",
  },
  ME: {
    code: "ME",
    name: "Crna Gora",
    nameGenitive: "Crnu Goru",
    currency: "EUR",
    deliveryPriceEur: 12,
    deliveryPrice: Math.round(12 * EUR_TO_RSD),
    freeShippingThreshold: null,
    pickupAllowed: false,
    phonePrefix: "+382",
    phonePlaceholder: "6x xxx xxx",
    deliveryEstimate: "4–7 radnih dana",
  },
  BA: {
    code: "BA",
    name: "Bosna i Hercegovina",
    nameGenitive: "Bosnu i Hercegovinu",
    currency: "EUR",
    deliveryPriceEur: 12,
    deliveryPrice: Math.round(12 * EUR_TO_RSD),
    freeShippingThreshold: null,
    pickupAllowed: false,
    phonePrefix: "+387",
    phonePlaceholder: "6x xxx xxx",
    deliveryEstimate: "4–7 radnih dana",
  },
};

export const COUNTRY_LIST = Object.values(COUNTRY_CONFIG);
export const DEFAULT_COUNTRY = "RS";

/* Prag besplatne dostave za podrazumevanu državu, za trust redove i korpu */
export const FREE_SHIPPING_THRESHOLD_RSD =
  COUNTRY_CONFIG[DEFAULT_COUNTRY].freeShippingThreshold;

/* Lično preuzimanje [BIZNIS: uneti stvarnu adresu i radno vreme] */
export const PICKUP_INFO = {
  city: "Novi Sad",
  address: "Adresa preuzimanja (biće potvrđena u porudžbini)",
  hours: "radnim danima 10–18h",
  note: "Javićemo ti se čim paket bude spreman za preuzimanje.",
};

/* Podaci o prodavcu, zakonska obaveza (v2 s.11.3)
   [BIZNIS: popuniti stvarne pravne podatke pre puštanja] */
export const SELLER_INFO = {
  legalName: "МРЧ",
  address: "Kragujevac, Srbija",
  pib: "u pripremi",
  maticniBroj: "u pripremi",
  phone: "+381 34 123 4567",
  supportHours: "radnim danima 9–17h",
};
